import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import HomeIcon from "@mui/icons-material/Home";
import {
  Form,
  Modal,
  Typography,
  Tooltip,
  Col,
  Flex,
  Badge,
  Avatar,
  Row,
} from "antd";

import SettingsIcon from "@mui/icons-material/Settings";
import type { TableProps } from "antd/es/table";
import { Dropdown, message } from "antd";
import { AppstoreOutlined, SearchOutlined } from "@ant-design/icons";
import { Skeleton } from "antd";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import PaidIcon from "@mui/icons-material/Paid";
import SellIcon from "@mui/icons-material/Sell";
import CancelIcon from "@mui/icons-material/Cancel";
import VerifiedIcon from "@mui/icons-material/Verified";
import ApartmentIcon from "@mui/icons-material/Apartment";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SingleBedIcon from "@mui/icons-material/SingleBed";
import CopyrightIcon from "@mui/icons-material/Copyright";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import UnpublishedIcon from "@mui/icons-material/Unpublished";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";

import type { MenuProps } from "antd";

import type { FilterValue, SorterResult } from "antd/es/table/interface";

import Highlighter from "react-highlight-words";
import type { InputRef } from "antd";
import { Button, Input, Space, Table } from "antd";
import type { ColumnType, ColumnsType } from "antd/es/table";
import type { FilterConfirmProps } from "antd/es/table/interface";
import {} from "@mui/x-data-grid";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { green, grey, red } from "@mui/material/colors";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import GavelIcon from "@mui/icons-material/Gavel";

import axios from "axios";

import Globais, {
  acertoPeriodosProprietario,
  enviarEmail,
  formatarData,
  logout,
  validateToken,
} from "../../components/Globais";

import MenuItem from "@mui/material/MenuItem";
import { NumberParam, StringParam, useQueryParams } from "use-query-params";
import ModalProprietarios from "./components/ModalProprietarios";
import ModalAnuncio from "./components/ModalAnuncio";
import { useAnuncioPropriedade } from "./hooks/useAnuncioPropriedade";
import { buscarAnuncioPropriedeByCotaUsuario } from "../../services/buscarAnuncioPropriedeByCotaUsuarioService";
import { useMediaQuery } from "@mui/material";
import ModalAdicionarPropriedade from "./components/ModalAdicionarPropriedade";
import ModalAssinatura from "./components/ModalAssinatura";
import ModalTroca from "./components/ModalTroca";
import ModalAndamentosCotaUsuario from "./components/ModalAndamentosCotaUsuario";
import ModalInabilitarCota from "./components/ModalInabilitarCota";
import { type InabilitarCotaUsuarioResponse } from "../../services/inabilitarCotaUsuarioService";

const Container = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  // Para garantir que o layout seja responsivo
  @media (max-width: 768px) {
    flex-direction: column; /* Empilhamento vertical em telas menores */
  }

  & > :first-child {
    flex: 0 0 10%; /* 10% para o topo */
  }

  & > :last-child {
    flex: 1; /* 90% para o conteúdo restante */
  }
`;
const ContainerFiltro = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: 100% / 5% 95%;

  justify-content: center;
  align-items: center;
`;
const ContainerTitulo = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  grid-column-start: 2;
  grid-row-start: 1;
`;
const ContainerSeta = styled.div`
  width: 100%;
  height: 100%;

  grid-column-start: 1;
  grid-row-start: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ContainerLista = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  min-width: 20rem;
  overflow: auto;
  padding: 1rem;
  grid-template: 10% 90% / auto;
`;

const BotoesAcoes = styled.button`
  border: none;
  color: blue;
  background-color: transparent;
  &: hover {
    cursor: pointer;
  }
`;
interface Values {
  title: string;
  description: string;
  modifier: string;
}

interface CollectionCreateFormProps {
  open: boolean;
  onCreate: (values: Values) => void;
  onCancel: () => void;
}
interface DataType {
  id: number;
  nome: string;
  sobrenome: string;
  usuarioId: number;
  cotaUsuarioId?: number;
  cotaId?: number;
  aptoId?: number;
  key: string;
  empreend: string;
  cidade: string;
  estado: string;
  numeroCota: number;
  checked: string;
  capacidade: string;
  aptoNome: string;
  nomeCidade: string;
  icone: string;
  perfil: string;
  origem: string;

  aceitaTroca: boolean;
  created_at: string;
}

type DataIndex = keyof DataType;

type MenuItem = Required<MenuProps>["items"][number];

const getStatusIconLabel = (status?: string) => {
  switch (status) {
    case "AGUARDANDO_CADASTRO":
      return "Cadastro pendente";
    case "AGUARDANDO_APTOMAISINFO":
      return "Cadastro pendente";
    case "AGUARDANDO_REPRESENTANTE":
      return "Cadastro pendente";
    case "AGUARDANDO_APTO":
      return "Aguardando apto";
    case "AGUARDANDO_PROCURACAO":
      return "Aguardando procuraÃ§Ã£o";
    case "AGUARDANDO_COMPROVANTE":
      return "Aguardando comprovante";
    case "AGUARDANDO_COTA":
      return "Aguardando cota";
    case "AGUARDANDO_TITULARIDADE":
      return "Aguardando titularidade";
    case "AGUARDANDO_PERIODOS":
      return "Aguardando periodos";
    case "AGUARDANDO_DEFINICAO_ANUNCIO":
      return "Cadastro pendente";
    case "AGUARDANDO_MAISINFO_ANUNCIO":
      return "Cadastro pendente";
    case "AGUARDANDO_DEFINICAO_PERIODOS":
      return "Aguardando definiÃ§Ã£o periodos";
    case "AGUARDANDO_PAGAMENTO":
      return "Aguardando pagamento";
    case "AGUARDANDO_AUTENTICACAO":
      return "Aguardando autenticaÃ§Ã£o";
    case "AUTENTICADA_NIVEL1":
      return "Autenticada n1";
    case "AUTENTICADA_NIVEL2":
      return "Autenticada n2";
    case "VENDENDO":
      return "A venda";
    case "CANCELADA":
      return "Cancelada";
    case "DISTRATO":
      return "Distrato";
    case "VENDIDA_MC":
      return "Vendida MC";
    case "VENDIDA_PROPRIO":
      return "Vendida Pr\u00f3prio";
    case "ERRO_INCLUSAO":
      return "Erro de inclusao";
    case "ATENCAO":
      return "Aten\u00e7\u00e3o";
    default:
      return "";
  }
};

export default function ViewGerenciarPropriedades() {
  const { Title } = Typography;
  const [nUserId, setNUserid] = useQueryParams({
    userId: NumberParam,
  });
  const [open, setOpen] = useState(false);
  const [nNome, setNome] = useQueryParams({ nomeProp: StringParam });
  const [empreendData, setEmpreendData] = useState<any>();
  const nome = useRef("");
  const nomeEmpreend = useRef("");
  const nomeProprietario = useRef("");
  const usuarioId = useRef<number>();
  const numeroCota = useRef(0);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  // const open = Boolean(anchorEl);

  const active = useRef("");
  const cotaUsuarioId = useRef(0);
  const userId = useRef(0);
  const [messageApi, contextHolder] = message.useMessage();

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);

  const [isLoading, setIsLoading] = useState(true);
  const perfil = useRef(0);

  const [filteredInfo, setFilteredInfo] = useState<
    Record<string, FilterValue | null>
  >({});
  const [sortedInfo, setSortedInfo] = useState<SorterResult<DataType>>({});

  const [semFiltros, setSemFiltros] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const contadorAguardandoPagamento = useRef(0);
  const contadorAguardandoProcuracao = useRef(0);
  const contadorAguardandoAutenticacao = useRef(0);

  const aceitaTroca = useRef(false);

  const clearFilters = () => {
    setFilteredInfo({});
  };

  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: "group"
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }

  const success = (texto: string) => {
    messageApi.open({
      type: "success",
      content: texto,
    });
  };

  const warning = (texto: string) => {
    messageApi.open({
      type: "warning",
      content: texto,
    });
  };

  const { TextArea } = Input;

  const error = (texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
    });
  };
  const CollectionCreateForm: React.FC<CollectionCreateFormProps> = ({
    open,
    onCreate,
    onCancel,
  }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={open}
        title="Mandar E-mail"
        okText="Enviar"
        cancelText="Cancelar"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              form.resetFields();
              onCreate(values);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          name="form_in_modal"
          initialValues={{ modifier: "public" }}
        >
          <Form.Item
            name="title"
            label="Assunto"
            rules={[
              { required: true, message: "Por favor insira um assunto!" },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="description"
            label="Mensagem"
            rules={[
              { required: true, message: "Por favor insira uma mensagem!" },
            ]}
          >
            <TextArea size="large" autoSize={{ minRows: 2, maxRows: 6 }} />
          </Form.Item>
          <Form.Item
            name="modifier"
            className="collection-create-form_last-form-item"
          ></Form.Item>
        </Form>
      </Modal>
    );
  };
  const onClick: MenuProps["onClick"] = async ({ key }) => {
    const Token = validateToken();
    const perfil = Token?.nda;
    let nomeProp = nome.current;

    // const situacao = active.current;
    const id = cotaUsuarioId.current;

    switch (key) {
      case "1":
        localStorage.removeItem("filtrosGerPeriodoUsuario");
        localStorage.removeItem("pageGerPeriodoUsuario");
        document.location.href = `/gerenciarPeriodosUsuarios/?userId=${
          nUserId.userId
        }&&nomeProp=${
          nNome.nomeProp ? nNome.nomeProp : nomeProprietario.current
        }&&cotaUsuarioId=${id}&&nomeEmpreend=${
          nomeEmpreend.current
        }&&numeroCota=${numeroCota.current}`;
        break;
      case "2":
        if (Token) {
          const URL = `${Globais.DOMINIOBACK}/cota-usuario/${id}`;
          let formData = {
            checked: 1,
            status: "AUTENTICADA_NIVEL1",
          };
          ////
          try {
            const response = await axios.put(URL, formData, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              success("Situação da propriedade alterada com sucesso!");
              setTimeout(() => {
                document.location.reload();
              }, 2000);
            } else {
              error("Algo deu errado!");
            }
          } catch (error) {
            error("Algo deu errado!");
          }
        } else {
          document.location.href = "/";
        }
        break;
      case "3":
        if (Token) {
          const URL = `${Globais.DOMINIOBACK}/cota-usuario/${id}`;
          let formData = {
            checked: 1,
            status: "AUTENTICADA_NIVEL2",
          };
          ////
          try {
            const response = await axios.put(URL, formData, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              if (response) {
                success("Situação da propriedade alterada com sucesso!");
                setTimeout(() => {
                  document.location.reload();
                }, 2000);
              } else {
                error("Algo deu errado!");
              }
            } else {
              error("Algo deu errado!");
            }
          } catch (error) {
            error("Algo deu errado!");
          }
        } else {
          document.location.href = "/";
        }
        break;

      case "4":
        //Ver documentos
        document.location.href = `/gerenciarDocumentosProprietarios/?cotaUsuarioId=${cotaUsuarioId.current}`;
        break;

      case "5":
        if (Token) {
          const URL = `${Globais.DOMINIOBACK}/cota-usuario/${id}`;
          let formData = {
            checked: 0,
            status: "AGUARDANDO_COMPROVANTE",
          };
          ////
          try {
            const response = await axios.put(URL, formData, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              success("Situação da propriedade alterada com sucesso!");
              setTimeout(() => {
                document.location.reload();
              }, 2000);
            } else {
              error("Algo deu errado!");
            }
          } catch (error) {
            error("Algo deu errado!");
          }
        } else {
          document.location.href = "/";
        }
        break;
      case "6":
        error("Fale com administrador.");
        break;
      case "7":
        const resposta = enviarEmail({ userId: nUserId.userId, tipoEmail: 2 });
        if (await resposta) {
          success("Mensagem enviada com sucesso!");
          setTimeout(() => {
            document.location.reload();
          }, 2000);
        } else {
          error("Algo deu errado!");
        }

        break;
      case "8":
        if (nUserId.userId) {
          userId.current = +nUserId.userId;
          setOpen(true);
        }

        // if (Token) {
        //   const URL = `${Globais.DOMINIOBACK}/usuario/${id}`;
        //   let formData = { nda: 3 };
        //   ////
        //   try {
        //     const response = await axios.put(URL, formData, {
        //       headers: { Authorization: Token.AuthStr },
        //     });
        //     if (response) {
        //       success("Usuário selecionado agora é um representante!");
        //       setTimeout(() => {
        //         document.location.reload();
        //       }, 2000);
        //     } else {
        //       error("Algo deu errado!");
        //     }
        //   } catch (error) {
        //     error("Algo deu errado!");
        //   }
        // } else {
        //   document.location.href = "/";
        // }
        break;
      case "9":
        // if (perfil === 1) {
        //   if (Token) {
        //     const URL = `${Globais.DOMINIOBACK}/usuario/${id}`;
        //     let formData = { nda: 2 };
        //     ////
        //     try {
        //       const response = await axios.put(URL, formData, {
        //         headers: { Authorization: Token.AuthStr },
        //       });
        //       if (response) {
        //         success("Usuário selecionado agora é um operador!");
        //         setTimeout(() => {
        //           document.location.reload();
        //         }, 2000);
        //       } else {
        //         error("Algo deu errado!");
        //       }
        //     } catch (error) {
        //       error("Algo deu errado!");
        //     }
        //   } else {
        //     document.location.href = "/";
        //   }
        // } else {
        //   error("Somente administradores podem atribuir o perfil de operador");
        // }

        break;
      case "10":
        // acertar períodos
        const result = acertoPeriodosProprietario(
          userId.current,
          cotaUsuarioId.current
        );

        if ((await result) === 1) {
          success("Períodos do proprietário atualizado com sucesso");
        } else {
          error("Erro ao acertar períodos do proprietário");
        }

        break;
      case "11":
        document.location.href = `/representantes/?cotaUsuarioId=${cotaUsuarioId.current}&nomeEmpreend=${nomeEmpreend.current}&numeroCota=${numeroCota.current}`;
        break;
      case "12":
        showModal();
        break;
      case "13":
        document.location.href = `/cadastroPropriedade/detalhes/${cotaUsuarioId.current}`;
        break;
      case "14":
      case "14":
        const anuncio = await getAnuncioPropriedade(cotaUsuarioId.current);
        if (anuncio) {
          showModalAnuncio();
        } else {
          warning("Não há anúncio para esta propriedade");
        }
        break;
      case "15":
        handleModalAssinatura();
        break;
      case "16":
        handleModalTroca();
        break;
      case "17":
        showModalInabilitarCota();
        break;
      case "18":
        showModalAndamentosCotaUsuario();
        break;
    }
  };

  const getAnuncioPropriedade = async (cotaUsuarioId: number) => {
    try {
      const data = await buscarAnuncioPropriedeByCotaUsuario(cotaUsuarioId);
      if (data) {
        
        return data[0];
      } else {
        return false;
      }
    } catch (err) {
      console.error("Erro ao buscar anuncio propriedade:", err);
      return false;
    }
  };

  const items: MenuProps["items"] = [
    { key: "1", label: "Períodos" },
    { key: "4", label: "Documentos" },
    { key: "11", label: "Representantes" },
    getItem("Mudar Situação", "sub2", <AppstoreOutlined />, [
      getItem("Autenticado nível 1", "2"),
      getItem("Autenticado nível 2", "3"),
      getItem("Aguardando comprovante", "5"),
    ]),
    // { key: "2", label: "Ver interesses" },

    { key: "6", label: "Excluir" },
    getItem("Mandar mensagem", "sub3", <AppstoreOutlined />, [
      getItem("De autenticação", "7"),
      getItem("Genérica", "8"),
    ]),
    { key: "9", label: "Incluir mais informações" },
    { key: "10", label: "Acertar períodos" },
    { key: "12", label: "Proprietário" },
    { key: "13", label: "Detalhes" },
    { key: "18", label: "Andamentos" },
    { key: "14", label: "Anúncio" },
    { key: "15", label: "Criar Assinatura" },
    { key: "16", label: "Aceita Troca" },
    { key: "17", label: "Inabilitar Cota" },
  ];

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      const props = {};

      let obj = localStorage.getItem("filtrosPropriedades");
      let page = localStorage.getItem("pageGerPropriedades");
      if (obj) {
        let novoFiltro = JSON.parse(obj);

        setFilteredInfo({
          empreend: novoFiltro.empreend,
          nome: novoFiltro.nome,
          nomeCidade: novoFiltro.nomeCidade,
          numeroCota: novoFiltro.numeroCota,
          infoApt: novoFiltro.infoApt,
          capacidade: novoFiltro.capacidade,
          created_at: novoFiltro.created_at,
          icone: novoFiltro.icone,
          perfil: novoFiltro.perfil,
          origem: novoFiltro.origem,
        });

        setSemFiltros(false);
      }
      if (page) {
        setCurrentPage(+page);
        setSemFiltros(false);
      }

      if (Token) {
        if (Token.nda === 0) {
          document.location.href = "/sempermissao";
        }

        if (nUserId.userId === 0) {
          const URL = `${Globais.DOMINIOBACK}/cota-usuario/usuario/${nUserId.userId}/0`;
          try {
            const response = await axios.get(URL, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              let ArrayNovo = response.data.filter(async (p: any) => {
                p.key = p.id;
                p.nome = `${p.UsuarioTable.nome} ${p.UsuarioTable.sobrenome}`;
                p.empreend = p.CotaTable.AptoTable.EmpreendimentoTable.nome;
                p.cidade =
                  p.CotaTable.AptoTable.EmpreendimentoTable.CidadeTable.nome;
                p.estado =
                  p.CotaTable.AptoTable.EmpreendimentoTable.CidadeTable.EstadoTab.abreviacao;
                p.numeroCota = p.CotaTable.numeroCota;
                p.cotaUsuarioId = p.id;
                p.status = p.status;
                p.usuarioId = p.usuarioId;
                p.origem =
                  p.CotaTable.AptoTable.EmpreendimentoTable.origem == 0
                    ? "MultiCotas"
                    : "Usuário";
                p.aceitaTroca = p.aceitaTroca;

                if (p.status === "AGUARDANDO_PAGAMENTO") {
                  contadorAguardandoPagamento.current++;
                }
                if (p.status === "AGUARDANDO_AUTENTICACAO") {
                  contadorAguardandoAutenticacao.current++;
                }
                if (p.status === "AGUARDANDO_PROCURACAO") {
                  contadorAguardandoProcuracao.current++;
                }
                if (p.active === 0) {
                  p.checked = "Cancelada";
                } else {
                  if (p.checked === 0) {
                    p.checked = "Não autenticada";
                  } else {
                    if (p.checked === 1) {
                      p.checked = "Autenticada";
                    }
                  }
                }
                if (p.bloco && p.numeroApto) {
                  p.infoApt = `${p.bloco} - ${p.numeroApto}`;
                } else {
                  p.infoApt = "";
                }

                p.nomeCidade = `${p.cidade} - ${p.estado}`;

                // eslint-disable-next-line no-self-assign
                p.cotaId = p.cotaId;
                p.aptoId = p.CotaTable.AptoTable.id;
                p.banheiros = p.CotaTable.AptoTable.banheiros;
                p.capacidade = p.CotaTable.AptoTable.capacidade;
                if (p.CotaTable.AptoTable.estacionamento === 0) {
                  p.estacionamento = "Não";
                } else {
                  if (p.CotaTable.AptoTable.estacionamento === 1) {
                    p.estacionamento = "Sim";
                  }
                }
                p.aptoNome = p.CotaTable.AptoTable.nome;
                p.metragem = p.CotaTable.AptoTable.metragem;
                p.created_at = formatarData(p.created_at);
                p.origemApto = p.CotaTable.AptoTable.origem;
                p.quartos = p.CotaTable.AptoTable.quartos;
                if (p.CotaTable.AptoTable.terreo === 0) {
                  p.terreo = "Não";
                } else {
                  if (p.CotaTable.AptoTable.terreo === 1) {
                    p.terreo = "Sim";
                  }
                }
                if (p.CotaTable.AptoTable.varanda === 2) {
                  p.varanda = "Não";
                } else {
                  if (p.CotaTable.AptoTable.varanda === 1) {
                    p.varanda = "Sim";
                  }
                }
                switch (p.status) {
                  case "AGUARDANDO_CADASTRO":
                    p.icone = "Cadastro pendente";
                    break;
                  case "AGUARDANDO_APTO":
                    p.icone = "Aguardando apto";
                    break;
                  case "AGUARDANDO_PROCURACAO":
                    p.icone = "Aguardando procuração";
                    break;
                  case "AGUARDANDO_COMPROVANTE":
                    p.icone = "Aguardando comprovante";
                    break;
                  case "AGUARDANDO_COTA":
                    p.icone = "Aguardando cota";
                    break;
                  case "AGUARDANDO_TITULARIDADE":
                    p.icone = "Aguardando titularidade";
                    break;
                  case "AGUARDANDO_PERIODOS":
                    p.icone = "Aguardando periodos";
                    break;
                  case "AGUARDANDO_PAGAMENTO":
                    p.icone = "Aguardando pagamento";
                    break;
                  case "AGUARDANDO_AUTENTICACAO":
                    p.icone = "Aguardando autenticação";
                    break;
                  case "AUTENTICADA_NIVEL1":
                    p.icone = "Autenticada n1";
                    break;
                  case "AUTENTICADA_NIVEL2":
                    p.icone = "Autenticada n2";
                    break;
                  case "VENDENDO":
                    p.icone = "A venda";
                    break;
                  case "CANCELADA":
                    p.icone = "Cancelada";
                    break;
                  case "DISTRATO":
                    p.icone = "Distrato";
                    break;
                  case "VENDIDA_MC":
                    p.icone = "Vendida MC";
                    break;
                  case "VENDIDA_PROPRIO":
                    p.icone = "Vendida Próprio";
                    break;
                }
                if (p.status === "ATENCAO") {
                  p.icone = "Aten\u00e7\u00e3o";
                }
                if (p.status === "ATENCAO") {
                  p.icone = "Aten\u00e7\u00e3o";
                }
                p.icone = p.icone ?? getStatusIconLabel(p.status);
                return p;
              });

              setEmpreendData(ArrayNovo);
              setIsLoading(false);
            }
          } catch (error) {
            if (error.response.status === 401) {
              logout();
            }
          }
        } else {
          perfil.current = Token.nda;
          const URL = `${Globais.DOMINIOBACK}/cota-usuario/usuario/${nUserId.userId}/0`;
          const URLRepresentantes = `${Globais.DOMINIOBACK}/representante/usuario/${nUserId.userId}`;

          try {
            const response = await axios.get(URL, {
              headers: { Authorization: Token.AuthStr },
            });
            const responseRepresentantes = await axios.get(URLRepresentantes, {
              headers: { Authorization: Token.AuthStr },
            });

            if (response && responseRepresentantes) {
              let ArrayNovo = response.data.filter(async (p: any) => {
                p.key = p.id;
                p.perfil = "Proprietário";
                p.empreend = p.CotaTable.AptoTable.EmpreendimentoTable.nome;
                p.nome = `${p.UsuarioTable.nome} ${p.UsuarioTable.sobrenome}`;
                p.cidade =
                  p.CotaTable.AptoTable.EmpreendimentoTable.CidadeTable.nome;
                p.estado =
                  p.CotaTable.AptoTable.EmpreendimentoTable.CidadeTable.EstadoTab.abreviacao;
                p.numeroCota = p.CotaTable.numeroCota;
                p.cotaUsuarioId = p.id;
                p.usuarioId = p.usuarioId;
                p.origem =
                  p.CotaTable.AptoTable.EmpreendimentoTable.origem == 0
                    ? "MultiCotas"
                    : "Usuário";
                p.aceitaTroca = p.aceitaTroca;
                if (p.active === 0) {
                  p.checked = "Cancelada";
                } else {
                  if (p.checked === 0) {
                    p.checked = "Não autenticada";
                  } else {
                    if (p.checked === 1) {
                      p.checked = "Autenticada";
                    }
                  }
                }
                if (p.bloco && p.numeroApto) {
                  p.infoApt = `${p.bloco} - ${p.numeroApto}`;
                } else {
                  p.infoApt = "";
                }

                p.nomeCidade = `${p.cidade} - ${p.estado}`;

                // eslint-disable-next-line no-self-assign
                p.cotaId = p.cotaId;
                p.aptoId = p.CotaTable.AptoTable.id;
                p.banheiros = p.CotaTable.AptoTable.banheiros;
                p.capacidade = p.CotaTable.AptoTable.capacidade;
                if (p.CotaTable.AptoTable.estacionamento === 0) {
                  p.estacionamento = "Não";
                } else {
                  if (p.CotaTable.AptoTable.estacionamento === 1) {
                    p.estacionamento = "Sim";
                  }
                }
                p.aptoNome = p.CotaTable.AptoTable.nome;
                p.metragem = p.CotaTable.AptoTable.metragem;
                p.created_at = formatarData(p.created_at);
                p.origemApto = p.CotaTable.AptoTable.origem;
                p.quartos = p.CotaTable.AptoTable.quartos;
                if (p.CotaTable.AptoTable.terreo === 0) {
                  p.terreo = "Não";
                } else {
                  if (p.CotaTable.AptoTable.terreo === 1) {
                    p.terreo = "Sim";
                  }
                }
                if (p.CotaTable.AptoTable.varanda === 2) {
                  p.varanda = "Não";
                } else {
                  if (p.CotaTable.AptoTable.varanda === 1) {
                    p.varanda = "Sim";
                  }
                }
                switch (p.status) {
                  case "AGUARDANDO_CADASTRO":
                    p.icone = "Cadastro pendente";
                    break;
                  case "AGUARDANDO_APTO":
                    p.icone = "Aguardando apto";
                    break;
                  case "AGUARDANDO_PROCURACAO":
                    p.icone = "Aguardando procuração";
                    break;
                  case "AGUARDANDO_COMPROVANTE":
                    p.icone = "Aguardando comprovante";
                    break;
                  case "AGUARDANDO_COTA":
                    p.icone = "Aguardando cota";
                    break;
                  case "AGUARDANDO_TITULARIDADE":
                    p.icone = "Aguardando titularidade";
                    break;
                  case "AGUARDANDO_PERIODOS":
                    p.icone = "Aguardando periodos";
                    break;
                  case "AGUARDANDO_DEFINICAO_PERIODOS":
                    p.icone = "Aguardando definição periodos";
                    break;
                  case "AGUARDANDO_PAGAMENTO":
                    p.icone = "Aguardando pagamento";
                    break;
                  case "AGUARDANDO_AUTENTICACAO":
                    p.icone = "Aguardando autenticação";
                    break;
                  case "AUTENTICADA_NIVEL1":
                    p.icone = "Autenticada n1";
                    break;
                  case "AUTENTICADA_NIVEL2":
                    p.icone = "Autenticada n2";
                    break;
                  case "VENDENDO":
                    p.icone = "A venda";
                    break;
                  case "CANCELADA":
                    p.icone = "Cancelada";
                    break;
                  case "DISTRATO":
                    p.icone = "Distrato";
                    break;
                  case "VENDIDA_MC":
                    p.icone = "Vendida MC";
                    break;
                  case "VENDIDA_PROPRIO":
                    p.icone = "Vendida Próprio";
                    break;
                }

                p.icone = p.icone ?? getStatusIconLabel(p.status);
                return p;
              });

              if (responseRepresentantes.data) {
                responseRepresentantes.data.filter((r: any) => {
                  r.key = r.id;
                  r.perfil = "Representante";
                  r.empreend =
                    r.CotasUsuariosTable.CotaTable.AptoTable.EmpreendimentoTable.nome;
                  r.nome = `${r.CotasUsuariosTable.UsuarioTable.nome} ${r.CotasUsuariosTable.UsuarioTable.sobrenome}`;
                  r.created_at = formatarData(r.created_at);
                  r.cidade =
                    r.CotasUsuariosTable.CotaTable.AptoTable.EmpreendimentoTable.CidadeTable.nome;
                  r.estado =
                    r.CotasUsuariosTable.CotaTable.AptoTable.EmpreendimentoTable.CidadeTable.EstadoTab.abreviacao;
                  r.numeroCota = r.CotasUsuariosTable.CotaTable.numeroCota;
                  r.cotaUsuarioId = r.CotasUsuariosTable.id;
                  r.usuarioId = r.CotasUsuariosTable.usuarioId;
                  r.cotaId = r.CotasUsuariosTable.CotaTable.id;
                  r.aptoId = r.CotasUsuariosTable.CotaTable.AptoTable.id;
                  r.capacidade =
                    r.CotasUsuariosTable.CotaTable.AptoTable.capacidade;
                  r.aptoNome = r.CotasUsuariosTable.CotaTable.AptoTable.nome;
                  r.situacao = "Representante";
                  r.aceitaTroca = r.CotasUsuariosTable.aceitaTroca;

                  if (
                    r.CotasUsuariosTable.bloco &&
                    r.CotasUsuariosTable.numeroApto
                  ) {
                    r.infoApt = `${r.CotasUsuariosTable.bloco} - ${r.CotasUsuariosTable.numeroApto}`;
                  } else {
                    r.infoApt = "";
                  }

                  r.nomeCidade = `${r.CotasUsuariosTable.CotaTable.AptoTable.EmpreendimentoTable.CidadeTable.nome} - ${r.CotasUsuariosTable.CotaTable.AptoTable.EmpreendimentoTable.CidadeTable.EstadoTab.abreviacao}`;

                  if (
                    r.CotasUsuariosTable.status === "AGUARDANDO_AUTENTICACAO" ||
                    r.CotasUsuariosTable.status === "AGUARDANDO_APTOMAISINFO" ||
                    r.CotasUsuariosTable.status ===
                      "AGUARDANDO_REPRESENTANTE" ||
                    r.CotasUsuariosTable.status === "AGUARDANDO_PROCURACAO" ||
                    r.CotasUsuariosTable.status === "AGUARDANDO_CADASTRO" ||
                    r.CotasUsuariosTable.status === "AGUARDANDO_APTO" ||
                    r.CotasUsuariosTable.status === "AGUARDANDO_TITULARIDADE" ||
                    r.CotasUsuariosTable.status === "AGUARDANDO_COMPROVANTE" ||
                    r.CotasUsuariosTable.status === "AGUARDANDO_COTA" ||
                    r.CotasUsuariosTable.status === "AGUARDANDO_PERIODOS" ||
                    r.CotasUsuariosTable.status ===
                      "AGUARDANDO_DEFINICAO_ANUNCIO" ||
                    r.CotasUsuariosTable.status ===
                      "AGUARDANDO_MAISINFO_ANUNCIO" ||
                    r.CotasUsuariosTable.status ===
                      "AGUARDANDO_DEFINICAO_PERIODOS"
                  ) {
                    r.icone = "Cadastro pendente";
                  } else {
                    if (
                      r.CotasUsuariosTable.status === "AUTENTICADA_NIVEL1" ||
                      r.CotasUsuariosTable.status === "AUTENTICADA_NIVEL2"
                    ) {
                      r.icone = "Autenticada";
                    } else {
                      if (r.CotasUsuariosTable.status === "VENDENDO") {
                        r.icone = "A Venda";
                      } else {
                        if (r.CotasUsuariosTable.status === "CANCELADA") {
                          r.icone = "Cancelada";
                        } else if (
                          r.CotasUsuariosTable.status === "VENDIDA_MC"
                        ) {
                          r.icone = "Vendida MC";
                        } else if (
                          r.CotasUsuariosTable.status === "VENDIDA_PROPRIO"
                        ) {
                          r.icone = "Vendida Próprio";
                        } else {
                          if (r.CotasUsuariosTable.status === "DISTRATO") {
                            r.icone = "Distrato";
                          } else {
                            if (
                              r.CotasUsuariosTable.status ===
                              "AGUARDANDO_PAGAMENTO"
                            ) {
                              r.icone = "Pendente pagamento";
                            }
                          }
                        }
                      }
                    }
                  }

                  r.status = r.CotasUsuariosTable.status;
                  r.icone =
                    r.icone ?? getStatusIconLabel(r.CotasUsuariosTable.status);
                  ArrayNovo.push(r);
                });
              }

              setEmpreendData(ArrayNovo);
              setIsLoading(false);
            }
          } catch (error) {
            if (error.response.status === 401) {
              logout();
            }
          }
        }
      }
    };
    fetchToken();
  }, []);

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 100 }}
          >
            Pesquisar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      String(record[dataIndex] ?? "")
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns: ColumnsType<DataType> = [
    {
      title: "Nome do Proprietário",
      dataIndex: "nome",
      key: "nome",
      width: "30%",
      filteredValue: filteredInfo.nome || null,
      ...getColumnSearchProps("nome"),
      sorter: (a, b) => a.nome.length - b.nome.length,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Empreendimento",
      dataIndex: "empreend",
      key: "empreend",
      width: "30%",
      filteredValue: filteredInfo.empreend || null,
      ...getColumnSearchProps("empreend"),
      sorter: (a, b) => a.empreend.length - b.empreend.length,
      sortDirections: ["descend", "ascend"],
    },

    {
      title: "Cidade",
      dataIndex: "nomeCidade",
      key: "nomeCidade",
      filteredValue: filteredInfo.nomeCidade || null,
      width: "20%",
      ...getColumnSearchProps("nomeCidade"),
    },
    {
      title: "Nº Cota",
      dataIndex: "numeroCota",
      key: "numeroCota",
      filteredValue: filteredInfo.numeroCota || null,
      width: "5%",
      ...getColumnSearchProps("numeroCota"),
    },
    {
      title: "Bloco / Nº Apto",
      dataIndex: "infoApt",
      key: "infoApt",
      filteredValue: filteredInfo.infoApt || null,
      width: "10%",
      align: "center",
    },
    {
      title: "Capacidade",
      dataIndex: "capacidade",
      key: "capacidade",
      filteredValue: filteredInfo.capacidade || null,
      width: "10%",
      ...getColumnSearchProps("capacidade"),
    },
    {
      title: "Perfil",
      dataIndex: "perfil",
      key: "perfil",
      filteredValue: filteredInfo.perfil || null,
      width: "10%",
      filters: [
        { text: "Proprietário", value: "Proprietário" },
        { text: "Representante", value: "Representante" },
      ],
      onFilter: (value: any, record) => record.perfil === value,
      filterSearch: true,
    },
    {
      title: "Origem",
      dataIndex: "origem",
      key: "origem",
      filteredValue: filteredInfo.origem || null,
      width: "10%",
      filters: [
        { text: "MultiCotas", value: "MultiCotas" },
        { text: "Usuário", value: "Usuário" },
      ],
      onFilter: (value: any, record) => record.origem === value,
      filterSearch: true,
    },

    {
      title: "Status",
      dataIndex: "icone",
      key: "icone",
      width: "10%",
      filters: [
        { text: "Cadastro pendente", value: "Cadastro pendente" },
        { text: "Aguardando apto", value: "Aguardando apto" },
        { text: "Aguardando procuração", value: "Aguardando procuração" },
        // { text: "Aguardando procuração", value: "Aguardando procuração" },
        { text: "Aguardando cota", value: "Aguardando cota" },
        { text: "Aguardando titularidade", value: "Aguardando titularidade" },
        { text: "Aguardando periodos", value: "Aguardando periodos" },
        {
          text: "Aguardando definição periodos",
          value: "Aguardando definição periodos",
        },
        { text: "Aguardando pagamento", value: "Aguardando pagamento" },
        { text: "Aguardando autenticação", value: "Aguardando autenticação" },
        { text: "Autenticada n1", value: "Autenticada n1" },
        { text: "Autenticada n2", value: "Autenticada n2" },
        { text: "A venda", value: "A venda" },
        { text: "Vendida MC", value: "Vendida MC" },
        { text: "Vendida Próprio", value: "Vendida Próprio" },
        { text: "Cancelada", value: "Cancelada" },
        { text: "Distrato", value: "Distrato" },
        { text: "Aten\u00e7\u00e3o", value: "Aten\u00e7\u00e3o" },
      ],
      filteredValue: filteredInfo.icone || [],
      onFilter: (value: any, record) => record.icone === value,
      filterSearch: true,

      render: (item, row) => {
        console.log("[ViewGerenciarPropriedades][StatusIcon]", {
          id: row.id,
          nome: row.nome,
          numeroCota: row.numeroCota,
          status: (row as any).status,
          icone: row.icone,
        });

        return row.icone === "Cadastro pendente" ? (
          <Tooltip title="Proprietário apenas começou o cadastro.">
            <PendingActionsIcon color="primary" />
          </Tooltip>
        ) : row.icone === "Autenticada" ? (
          <Tooltip title="Tudo certo! Propriedade autenticada.">
            <VerifiedIcon color="success" />
          </Tooltip>
        ) : row.icone === "Cancelada" ? (
          <Tooltip title="Propriedade cancelada">
            <CancelIcon color="error" />
          </Tooltip>
        ) : row.icone === "A venda" ? (
          <Tooltip title="Essa propriedade está sendo anunciada.">
            <SellIcon color="warning" />
          </Tooltip>
        ) : row.icone === "Vendida MC" ? (
          <Tooltip title="Essa propriedade já foi vendida pelo MC.">
            <PaidIcon color="success" />
          </Tooltip>
        ) : row.icone === "Distrato" ? (
          <Tooltip title="Distrato">
            <NotInterestedIcon color="error" />
          </Tooltip>
        ) : row.icone === "Erro de inclusao" ? (
          <Tooltip title="Cota inativada por erro de inclusao.">
            <CancelIcon color="error" />
          </Tooltip>
        ) : row.icone === "Aguardando apto" ? (
          <Tooltip title="Aguardando informações do apartamento">
            <ApartmentIcon color="primary" />
          </Tooltip>
        ) : row.icone === "Aguardando procuração" ? (
          <Tooltip title="Aguardando assinatura procuração">
            <BorderColorIcon color="primary" />
          </Tooltip>
        ) : row.icone === "Aguardando comprovante" ? (
          <Tooltip title="Aguardando anexar comprovante">
            <AttachFileIcon color="primary" />
          </Tooltip>
        ) : row.icone === "Aguardando cota" ? (
          <Tooltip title="Aguardando informações da cota">
            <SingleBedIcon color="primary" />
          </Tooltip>
        ) : row.icone === "Aguardando titularidade" ? (
          <Tooltip title="Aguardando informações da titularidade">
            <CopyrightIcon color="primary" />
          </Tooltip>
        ) : row.icone === "Aguardando periodos" ||
          row.icone === "Aguardando definição periodos" ? (
          <Tooltip title="Aguardando informações dos periodos">
            <CalendarMonthIcon color="primary" />
          </Tooltip>
        ) : row.icone === "Aguardando pagamento" ? (
          <Tooltip title="Aguardando pagamento anúncio">
            <ShoppingCartCheckoutIcon color="primary" />
          </Tooltip>
        ) : row.icone === "Aguardando autenticação" ? (
          <Tooltip title="Aguardando autenticação">
            <UnpublishedIcon color="warning" />
          </Tooltip>
        ) : row.icone === "Autenticada n1" ? (
          <Tooltip title="Autenticação sem foto">
            <DoneIcon color="success" />
          </Tooltip>
        ) : row.icone === "Autenticada n2" ? (
          <Tooltip title="Autenticação com foto">
            <DoneAllIcon color="success" />
          </Tooltip>
        ) : row.icone === "Vendida Próprio" ? (
          <Tooltip title="Vendida pelo proprietário">
            <PaidIcon color="success" />
          </Tooltip>
        ) : row.icone === "Aten\u00e7\u00e3o" || row.icone === "ATENCAO" ? (
          <Tooltip title="A cota exige ação antes da conclusão.">
            <WarningAmberIcon color="warning" />
          </Tooltip>
        ) : null;
      },
    },
    // {
    //   title: "Perfil",
    //   dataIndex: "nda",
    //   key: "nda",
    //   width: "20%",

    //   filters: [
    //     { text: "Administrador", value: "Administrador" },
    //     { text: "Proprietário", value: "Proprietário" },
    //     { text: "Representante", value: "Representante" },
    //   ],
    //   onFilter: (value: any, record) => record.nda.includes(value),
    //   filterSearch: true,
    // },
    {
      title: "Data de cadastro",
      dataIndex: "created_at",
      key: "created_at",
      width: "20%",
      filteredValue: filteredInfo.created_at || null,
      ...getColumnSearchProps("created_at"),
    },
    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                cotaUsuarioId.current = row.cotaUsuarioId ?? row.id;
                nomeEmpreend.current = row.empreend;
                numeroCota.current = row.numeroCota;
                usuarioId.current = row.usuarioId;
                nomeProprietario.current = row.nome;
                aceitaTroca.current = row.aceitaTroca;
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];

  const onChange: TableProps<DataType>["onChange"] = (
    pagination,
    filters,
    sorter,
    extra
  ) => {
    setFilteredInfo({
      empreend: filters.empreend,
      nome: filters.nome,
      nomeCidade: filters.nomeCidade,
      numeroCota: filters.numeroCota,
      infoApt: filters.infoApt,
      capacidade: filters.capacidade,
      created_at: filters.created_at,
      icone: filters.icone,
      perfil: filters.perfil,
      origem: filters.origem,
    });
    if (pagination.current) {
      let page = pagination.current.toString();
      localStorage.setItem("pageGerPropriedades", page);
    }

    localStorage.setItem("filtrosPropriedades", JSON.stringify(filters));
    setSemFiltros(false);
  };

  const removerFiltros = () => {
    localStorage.removeItem("filtrosPropriedades");
    localStorage.removeItem("pageGerPropriedades");
  };

  const handleFilter = () => {
    removerFiltros();
    setSemFiltros(true);
    document.location.reload();
  };

  // State de abertura e fechamento do modal
  const [openModalAssinatura, setOpenModalAssinatura] = useState(false);

  const handleModalAssinatura = () => {
    setOpenModalAssinatura(!openModalAssinatura);
  };

  // State de abertura e fechamento do modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Funçao para abrir o modal
  const showModal = () => {
    setIsModalOpen(true);
  };

  // Funçao para fechar o modal
  const handleFechar = () => {
    setIsModalOpen(false);
  };

  // State de abertura e fechamento do modal Anuncio
  const [isModalAnuncioOpen, setIsModalAnuncioOpen] = useState(false);

  // Funçao para abrir o modal Anuncio
  const showModalAnuncio = () => {
    setIsModalAnuncioOpen(true);
  };

  // Funçao para fechar o modal Anuncio
  const handleFecharAnuncio = () => {
    setIsModalAnuncioOpen(false);
  };

  // State de abertura e fechamento do modal (Adicionar Propriedade)
  const [isModalAdicionarOpen, setIsModalAdicionarOpen] = useState(false);

  const handleModalAdicionar = () => {
    setIsModalAdicionarOpen(!isModalAdicionarOpen);
  };

  const [openModalTroca, setOpenModalTroca] = useState(false);

  const handleModalTroca = () => {
    setOpenModalTroca(!openModalTroca);
  };

  const [openModalAndamentosCotaUsuario, setOpenModalAndamentosCotaUsuario] =
    useState(false);

  const showModalAndamentosCotaUsuario = () => {
    setOpenModalAndamentosCotaUsuario(true);
  };

  const handleFecharModalAndamentosCotaUsuario = () => {
    setOpenModalAndamentosCotaUsuario(false);
  };

  const [openModalInabilitarCota, setOpenModalInabilitarCota] =
    useState(false);

  const showModalInabilitarCota = () => {
    setOpenModalInabilitarCota(true);
  };

  const handleFecharModalInabilitarCota = () => {
    setOpenModalInabilitarCota(false);
  };

  const handleInabilitarCotaSuccess = (
    response: InabilitarCotaUsuarioResponse
  ) => {
    const statusFinal = response.statusFinal ?? response.cotaUsuario.status;
    const totalAnunciosComPendencia =
      response.anuncios?.totalComPendencia ??
      response.anuncios?.totalDatadosInativacao ??
      0;
    const temAssinaturaAtiva =
      (response.assinaturas?.totalNaoRenovar ?? 0) > 0;
    const temAnuncioAtivo = totalAnunciosComPendencia > 0;
    const statusExibido = statusFinal;

    setEmpreendData((currentData: any[] = []) =>
      currentData.map((item) =>
        item.id === response.cotaUsuario.id
          ? {
              ...item,
              status: statusExibido,
              active: response.cotaUsuario.active ?? item.active,
              checked:
                response.cotaUsuario.active === 0 ? "Cancelada" : item.checked,
              updated_at: response.cotaUsuario.updated_at,
              icone: getStatusIconLabel(statusExibido),
            }
          : item
      )
    );

    success("Cota inabilitada com sucesso!");

    if (statusFinal === "ATENCAO") {
      const motivosAtencao: string[] = [];

      if (!temAssinaturaAtiva && !temAnuncioAtivo) {
        motivosAtencao.push(
          "existem períodos ou reservas que exigem ação antes da conclusão"
        );
      }

      if (temAssinaturaAtiva) {
        motivosAtencao.push("foi encontrada assinatura ativa vinculada \u00e0 cota");
      }

      if (temAnuncioAtivo) {
        motivosAtencao.push(
          "foi encontrado anúncio ativo sem data de inativação ou com data futura"
        );
      }

      Modal.warning({
        title: "Cota marcada com atenção",
        content: `A cota foi marcada com atenção porque ${motivosAtencao.join(
          "; "
        )}.`,
      });
    }
  };

  const isMobile = useMediaQuery("(max-width:600px)");
  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <Container>
          {contextHolder}
          <Row>
            <Col span={5}>
              <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                <a href={`/inicio`}>
                  
                </a>
              </Flex>
            </Col>
            <Col span={12}>
              <Flex align="center" justify="center">
                <HomeIcon color="primary" fontSize="large" />
                <Title
                  style={{
                    marginLeft: 10,
                    marginTop: 10,
                    fontSize: isMobile ? "1.5rem" : "2rem",
                    color: "rgb(0, 54, 68)",
                  }}
                  level={3}
                >
                  {nUserId.userId === 0
                    ? "Todas as propriedades"
                    : `Propriedades de ${nNome.nomeProp}`}
                </Title>
              </Flex>
            </Col>
          </Row>
          <Row>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end", // Alinha o conteúdo à direita
                alignItems: "center",
                height: "auto",
                width: "90%", // Garante que ocupe toda a largura disponível
                gap: "20px", // Espaço entre os botões
              }}
            >
              {nUserId.userId !== 0 && (
                <Button
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "auto",
                  }}
                  onClick={handleModalAdicionar}
                  type="primary"
                >
                  + Propriedade
                </Button>
              )}

              <Flex justify="flex-end" align="center">
                <Tooltip title="Aguardando Pagamento">
                  <Badge
                    count={contadorAguardandoPagamento.current}
                    style={{ marginRight: 10 }} // Reduzi o espaçamento aqui
                    title="Aguardando Pagamento"
                  >
                    <Avatar
                      shape="square"
                      style={{
                        backgroundColor: "transparent",
                        border: "1px solid grey",
                        marginRight: 10, // Reduzi o espaçamento aqui
                      }}
                      size="large"
                    >
                      <AttachMoneyIcon color="primary" />
                    </Avatar>
                  </Badge>
                </Tooltip>

                <Tooltip title="Aguardando Procuração">
                  <Badge
                    count={contadorAguardandoProcuracao.current}
                    style={{ marginRight: 10 }} // Reduzi o espaçamento aqui
                  >
                    <Avatar
                      shape="square"
                      style={{
                        backgroundColor: "transparent",
                        border: "1px solid grey",
                        marginRight: 10, // Reduzi o espaçamento aqui
                      }}
                      size="large"
                    >
                      <BorderColorIcon color="primary" />
                    </Avatar>
                  </Badge>
                </Tooltip>

                <Tooltip title="Aguardando Autenticação">
                  <Badge
                    count={contadorAguardandoAutenticacao.current}
                    style={{ marginRight: 10 }} // Reduzi o espaçamento aqui
                  >
                    <Avatar
                      shape="square"
                      style={{
                        backgroundColor: "transparent",
                        border: "1px solid grey",
                        marginRight: 10, // Reduzi o espaçamento aqui
                      }}
                      size="large"
                    >
                      <UnpublishedIcon color="warning" />
                    </Avatar>
                  </Badge>
                </Tooltip>
              </Flex>

              {semFiltros ? (
                <Button
                  onClick={handleFilter}
                  type="primary"
                  disabled={true}
                  style={{ marginBottom: 8 }}
                >
                  <FilterAltIcon />
                </Button>
              ) : (
                <Button
                  onClick={handleFilter}
                  type="primary"
                  style={{ marginBottom: 8 }}
                >
                  <FilterAltOffIcon />
                </Button>
              )}
            </div>
            <Col span={isMobile ? 5 : 1}></Col>
            <Col
              span={22}
              style={{
                marginTop: isMobile ? 15 : 15,
                marginBottom: isMobile ? 30 : 50,
              }}
            >
              <Flex
                style={{
                  width: isMobile ? "auto" : "100%",
                  overflow: "auto",
                  marginLeft: 30,
                }}
              >
                <Table
                  columns={columns}
                  dataSource={empreendData}
                  onChange={onChange}
                  bordered
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: isMobile ? "auto" : "100%",
                    maxWidth: isMobile ? "none" : "100%",
                  }}
                />
              </Flex>
            </Col>
          </Row>
          <CollectionCreateForm
            open={open}
            onCreate={async function (values: Values): Promise<void> {
              let resposta = await enviarEmail({
                userId: userId.current,
                tipoEmail: 1,
                subjectEmail: values.title,
                bodyEmail: values.description,
              });
              if (resposta && resposta === "Mensagens enviadas com sucesso.") {
                success("Mensagens enviadas com sucesso."); // Exibe mensagem de sucesso
                setTimeout(() => {
                  document.location.reload();
                }, 2000);
              } else {
                if (
                  resposta &&
                  resposta === "Falha ao enviar WhatsApp. Mas e-mail enviado."
                ) {
                  warning(resposta.toString());
                } else if (
                  resposta &&
                  resposta === "Falha. Não foi enviado E-mail e Whatsapp."
                ) {
                  error(resposta.toString());
                } else {
                  error(
                    resposta
                      ? resposta.toString()
                      : "Mensagens não enviadas. Deu algo errado."
                  );
                }
              }
            }}
            onCancel={function (): void {
              setOpen(false);
            }}
          />
          <ModalProprietarios
            isModalOpen={isModalOpen}
            handleFechar={handleFechar}
            usuarioId={usuarioId.current}
          />
          <ModalAnuncio
            isModalOpen={isModalAnuncioOpen}
            handleFechar={handleFecharAnuncio}
            usuarioId={usuarioId.current}
            cotaUsuarioId={cotaUsuarioId.current}
          />
          <ModalAdicionarPropriedade
            isModalOpen={isModalAdicionarOpen}
            handleFechar={handleModalAdicionar}
            usuarioId={nUserId.userId ?? 0}
            cotaUsuarioId={cotaUsuarioId.current ?? 0}
          />
          <ModalAssinatura
            isModalOpen={openModalAssinatura}
            handleFechar={handleModalAssinatura}
            usuarioId={usuarioId.current}
            cotaUsuarioId={cotaUsuarioId.current}
          />
          <ModalTroca
            isModalOpen={openModalTroca}
            handleFechar={handleModalTroca}
            cotaUsuarioId={cotaUsuarioId.current}
            aceitaTroca={aceitaTroca.current}
          />
          <ModalAndamentosCotaUsuario
            isModalOpen={openModalAndamentosCotaUsuario}
            handleFechar={handleFecharModalAndamentosCotaUsuario}
            cotaUsuarioId={cotaUsuarioId.current}
            numeroCota={numeroCota.current}
          />
          <ModalInabilitarCota
            isModalOpen={openModalInabilitarCota}
            handleFechar={handleFecharModalInabilitarCota}
            cotaUsuarioId={cotaUsuarioId.current}
            onSuccess={handleInabilitarCotaSuccess}
          />
        </Container>
      )}
    </>
  );
}
